export { Alert } from "@mantine/core";
export type { AlertProps } from "@mantine/core";
export { getAlertOverrides } from "./Alert.styled";
